import { create } from "zustand";
import { Review } from "../types";
import { createReview, fetchReviewsForProduct } from "../services/reviewService";

interface ReviewStore {
  reviews: Review[];
  loading: boolean;
  error: string | null;
  fetchReviews: (productId: number) => Promise<void>;
  addReview: (productId: number, reviewData: Partial<Review>) => Promise<void>;
}

export const useReviewStore = create<ReviewStore>((set) => ({
    reviews: [],
    loading: false,
    error: null,
  
    fetchReviews: async (productId: number) => {
      set({ loading: true, error: null });
      try {
        const fetchedReviews = await fetchReviewsForProduct(productId);
        set({ reviews: fetchedReviews || [], loading: false });
      } catch (err) {
        set({ error: "Ошибка загрузки отзывов", loading: false, reviews: [] });
      }
    },
  
    addReview: async (productId: number, reviewData: Partial<Review>) => {
      try {
        await createReview(productId, reviewData);
        set((state) => ({
          reviews: [...state.reviews, { ...reviewData, status: "pending" } as Review],
        }));
      } catch (err) {
        console.error("Ошибка создания отзыва:", err);
      }
    },
  }));
  
